import {ChangeDetectionStrategy, Component, input} from "@angular/core";
import {GruppeId, HtmlTekst, LitenIkkeTomStreng} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {FeltValidatorer} from "felles-ng2/infrastruktur/angular/feltValidatorer";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {StandardValideringsfeilPipe} from "felles-ng2/pipes/StandardValideringsfeilPipe";
import {TranslateModule} from "@ngx-translate/core";

import {ArkivMappenodeDLM} from "felles-ng2/tjenester/datalager/ArkivDatatjeneste";
import {RiktekstRedigeringKomponent} from "web-ng2/delt/komponenter/skjema/riktekst-redigering/riktekst-redigering";

const debug = initDebugger('ArkivMappeSkjemaKomponent');

export type SkjemaType = ReturnType<typeof ArkivmappeSkjemaKomponent.opprettSkjema>;
export type SkjemaVerdier = SkjemaType['value'];
export type Spesifikasjon = { navn: LitenIkkeTomStreng; beskrivelse: HtmlTekst; };

/**
 * Skjema for å rediger arkivmappe
 */
@Component({
    selector: 'arkivmappe-skjema',
    templateUrl: 'arkivmappe-skjema.html',
    styleUrl: 'arkivmappe-skjema.scss',
    host: {'data-testid': 'arkivmappe-skjema'},
    imports: [
        FormsModule,
        MatFormField,
        MatInput,
        MatLabel,
        StandardValideringsfeilPipe,
        TranslateModule,
        ReactiveFormsModule,
        RiktekstRedigeringKomponent
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ArkivmappeSkjemaKomponent {

    static opprettSkjema() {
        return new FormGroup({
            navn: new FormControl('', {validators: FeltValidatorer.litenIkkeTomStreng}),
            beskrivelse: new FormControl<HtmlTekst | null>(null, {validators: FeltValidatorer.htmlTekst})
        });
    }

    static populerSkjema(skjema: SkjemaType, mappe: ArkivMappenodeDLM): void {
        skjema.patchValue(mappe);
    }

    static somSpesifikasjon(skjema: SkjemaType): Spesifikasjon {
        const verdier = skjema.value;
        return {
            navn: verdier.navn!,
            beskrivelse: verdier.beskrivelse!,
        }
    }

    skjema = input.required<SkjemaType>();
    gruppeId = input.required<GruppeId | null>();

    constructor() {

    }
}
